module.exports = __webpack_public_path__ + "img/dot.f2ff6269.svg";